module.exports = __webpack_public_path__ + "static/media/IMG_0553.7b820990.JPG";